import styled from 'styled-components'
import { spacing } from 'helpers'

export const ContentWrapper = styled.div`
  overflow: auto;
  height: 100%;
  padding: ${spacing(1)};
  padding-top: 0;
`
